export default {
    label_task:{
        en:"Divisions",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Division",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Division",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Division",
        bn:'ব্যবহারকারীর বিবরণ'
    },
}